import { render } from "./addcomment.vue?vue&type=template&id=70fe3d12"
import script from "./addcomment.vue?vue&type=script&lang=js"
export * from "./addcomment.vue?vue&type=script&lang=js"

import "./addcomment.vue?vue&type=style&index=0&id=70fe3d12&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__